var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "102px",
    height: "112px",
    viewBox: "0 0 102 112",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "No-Load-Found",
    transform: "translate(-750.000000, -317.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(364.000000, 317.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(386.030000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.010088, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn/pfj-copy",
    fill: "#CCCCCC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,49.4117647 C0,88.9411765 49.0706176,112 49.0706176,112 C49.0706176,112 98.1412353,88.9411765 98.1412353,49.4117647 C98.1412353,22.1232941 76.1706841,0 49.0706176,0 C21.9705512,0 0,22.1232941 0,49.4117647 Z",
    id: "Fill-1"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F9F9F9",
    cx: 49.0706176,
    cy: 49,
    rx: 38.5554853,
    ry: 38.5
  })), /*#__PURE__*/React.createElement("text", {
    id: "?",
    fontFamily: "ProximaNova-Bold, Proxima Nova",
    fontSize: 72,
    fontWeight: "bold",
    letterSpacing: -0.215680431,
    fill: "#CCCCCC"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 33.1618402,
    y: 74
  }, "?"))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/QuestionMark.d66d838a3f72001640a6a8d168a1c984.svg";
export { ForwardRef as ReactComponent };